import { render, staticRenderFns } from "./ForgetPasswordPanel.vue?vue&type=template&id=8610a582&scoped=true&"
import script from "./ForgetPasswordPanel.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswordPanel.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPasswordPanel.vue?vue&type=style&index=0&id=8610a582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8610a582",
  null
  
)

export default component.exports